import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';

import CourseDetailsPage from './pages/CourseDetailsPage';
import CourseContentPage from './pages/CourseContentPage';
import CourseListingPage from './pages/CourseListingPage';
import LoginPage from './pages/LoginPage';
import Header from './components/Header';
import EnrolledCoursesPage from './pages/EnrolledCoursesPage';
import JobPostAutomation from './pages/JobPostAutomation';
import PublicRoute from './components/PublicRoute';


function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Header />
        <Routes>
          {/* Default route redirects to courses */}
          <Route path="/" element={<Navigate to="/courses" />} />

          {/* Public Routes */}
          <Route
            path="/login"
            element={
              <PublicRoute>
                <LoginPage />
              </PublicRoute>
            }
          />
          <Route path="/courses" element={<CourseListingPage />} />
          <Route path="/courses/:courseId" element={<CourseDetailsPage />} />
          
          {/* Restricted Admin Route */}
          <Route
            path="/admin/job-post-automation"
            element={
              <ProtectedRoute>
                <JobPostAutomation />
              </ProtectedRoute>
            }
          />

          {/* Protected Routes */}
          <Route
            path="/courses/:courseId/content"
            element={
              <ProtectedRoute>
                <CourseContentPage />
              </ProtectedRoute>
            }
          />
          <Route path="/my-courses" element={<ProtectedRoute><EnrolledCoursesPage /></ProtectedRoute>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
